<template>
  <IconLucidePointer />
</template>
